import { Autocomplete, Chip, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { Field, FieldProps, FieldRenderProps, useForm } from "react-final-form";
import { IListOption } from "src/store/models/listOption.models";

import "./MultiSelectField.scss";

export interface IMultiSelectFieldProps<FieldValue>
  extends FieldProps<FieldValue, FieldRenderProps<FieldValue, HTMLInputElement | HTMLTextAreaElement>> {
  label?: string;
  placeholder?: string;
  options: IListOption[];
}

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    "& .MuiAutocomplete-root .MuiAutocomplete-tag": {
      margin: "2px",
      maxWidth: "none",
    },
    "& .MuiAutocomplete-root .MuiAutocomplete-inputRoot": {
      flexWrap: "nowrap",
      overflowX: "auto",
    },
  },
}));

const MultiSelectField2: React.FC<IMultiSelectFieldProps<IListOption[]>> = ({
  label,
  placeholder,
  options,
  name,
  onChange,
}) => {
  const form = useForm();
  const classes = useStyles();
  return (
    <div className="multi-select-field">
      <ul>
        <li>
          <label>{label}</label>
        </li>
        <li className={classes.root}>
          <Field name={name}>
            {({ input }) => (
              <FormControl sx={{ width: 400 }}>
                <Autocomplete
                  sx={{ height: 40 }}
                  multiple
                  limitTags={3}
                  disableCloseOnSelect
                  options={options}
                  getOptionLabel={option => option.key}
                  value={input.value || []}
                  renderInput={params => (
                    <TextField
                      variant="standard"
                      {...params}
                      placeholder={placeholder}
                      className="autocomplete-textbox"
                    />
                  )}
                  renderTags={(value: readonly IListOption[], getTagProps) => {
                    return value.map((option: IListOption, index: number) => {
                      const { key, ...tagProps } = getTagProps({ index });
                      return <Chip variant="filled" label={option.key} key={option.value} {...tagProps} />;
                    });
                  }}
                  onChange={(event, value) => {
                    const newValue = onChange ? onChange(event, value) : value;
                    form.change(name, newValue);
                  }}
                />
              </FormControl>
            )}
          </Field>
        </li>
      </ul>
    </div>
  );
};

export default MultiSelectField2;
